import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'


const Comment = ({ comment, name, image, imageTag, location }) => {
  
  return (
    <Link to="/testimonials">
      <div className="testimonial-content-wrapper testimonial-outer-div" style={{padding: "20px 30px"}}>
        {/* <div className="testimonial-avatar-image">
          <img src={image || "/img/2019-11-22T13_23_02.296Ztesti.jpg"} alt={imageTag || ''} />
        </div> */}
        <div className="testimonial-contetns-wrapper testimonial-inside">
          <img src="/img/double-coma.svg"/>
          <p>{comment}</p>
          <h6>{name}</h6>
          <h5>{location}</h5>
        </div>
      </div>
    </Link>
  )
}

Comment.propTypes = {
  comment: PropTypes.string,
  name: PropTypes.string,
  imageTag: PropTypes.string,
  image: PropTypes.string,
}

Comment.defaultProps = {
  comment: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex laborum veritatis animi dolor
  cum sint rerum tempora voluptatem dolore, accusantium, amet molestiae quibusdam alias,
  nemo natus laboriosam aliquam qui ipsam?`,
  name: 'Sara John',
  image: "/img/comment-image.png",
  imageTag: '',
}

export default Comment
